document.addEventListener("turbolinks:load", function() {
  // Defines a global function to configure any buttons on the current page to launch links in the same tab.
  window.configureSameTabButtons = function() {
    const $launchElement = $(".launch-in-same-tab");
    $launchElement.on("click", function() {
      launchInSameTab($(this).data("link"), $(this).data("target"), $(this).data("action"))
    })
    $launchElement.on("keypress", function() {
      if (event.key === "Enter"|| event.key === " ") {
        launchInSameTab($(this).data("link"), $(this).data("target"), $(this).data("action"))
      }
    })
  }

  // Launches the provided link in an existing tab with the same provided target name, if any.
  // A message containing the provided action string will then be posted to that tab.
  function launchInSameTab(link, target, action) {
    let appWindow = window.open("", target, "")
    try {
      // If we've refreshed the page, this will throw an exception
      if (appWindow.location.href === "about:blank") {
        appWindow.location.href = link
      }
    } catch(e) {
      // Page was refreshed.
      console.log("Page refreshed.")
    }
    // Send message to app window and switch to the existing tab.
    appWindow.focus()
    appWindow.postMessage({ "action": action }, "*")
    return true
  }
})
